import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const listaMotivosCancelacion= async ({ token, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.MOTIVO_CANCELACION.LIST}`, extraHeaders: { token: token } });;
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default listaMotivosCancelacion;